export enum actionTypes {
  CONDICIONES_IVA_FETCH = 'CONDICIONES_IVA_FETCH',
  CONDICIONES_IVA_SUCCESS = 'CONDICIONES_IVA_SUCCESS',
  CONDICIONES_IVA_ERROR = 'CONDICIONES_IVA_ERROR',
  CONDICIONES_IVA_RESET = 'CONDICIONES_IVA_RESET',
}

export enum CondicionesIvaStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface TipoCondicionIVA {
  id: number
  nombre: string
  codigoTipoNif: string
  tipoNif: string
  claseImpuesto: string
  habilitado: boolean
}

export interface CondicionesIvaState {
  status: CondicionesIvaStatus
  tiposCondicionesIva: Array<TipoCondicionIVA>
}

export interface CondicionesIvaFetch {
  type: typeof actionTypes.CONDICIONES_IVA_FETCH
  payload: null
}

export interface CondicionesIvaSuccess {
  type: typeof actionTypes.CONDICIONES_IVA_SUCCESS
  payload: Array<TipoCondicionIVA>
}

export interface CondicionesIvaError {
  type: typeof actionTypes.CONDICIONES_IVA_ERROR
  payload: null
}

export interface CondicionesIvaReset {
  type: typeof actionTypes.CONDICIONES_IVA_RESET
  payload: null
}

export type CondicionesIvaActions =
  | CondicionesIvaFetch
  | CondicionesIvaSuccess
  | CondicionesIvaError
  | CondicionesIvaReset

export const initialState: CondicionesIvaState = {
  status: CondicionesIvaStatus.Idle,
  tiposCondicionesIva: [],
}
